"use client";

/**
 * El 404 dentro del árbol de locale. El cuerpo lo comparte con el 404 raíz
 * (`src/app/not-found.tsx`); acá solo se aportan los textos traducidos.
 */
import { useTranslations } from "next-intl";
import { NoEncontrada } from "@/components/marketing/NoEncontrada";

export default function NotFoundClient() {
  const t = useTranslations("notFound");
  return (
    <NoEncontrada
      textos={{
        titulo: t("title"),
        descripcion: t("description"),
        irAlInicio: t("goHome"),
        escribenos: t("writeUs"),
      }}
    />
  );
}
